export const PMI_DEVICE_PAGE_HELP_ENTRIES = [
  {
    routePrefix: '/pmi-devices',
    title: 'PMI Devices',
    description: 'PMI устройства с филтри и редакция на данни.',
    points: [
      'Използвайте filter panel за city/segment/status.',
      'Edit формата записва промени по избраното устройство.',
      'След промяна проверявайте Last Seen и активен статус.',
    ],
  },
  {
    routePrefix: '/pmi-devicesP',
    title: 'PMI Devices P',
    description: 'Основен оперативен изглед за PMI устройства.',
    points: [
      'SSE статусът показва дали идват live now-playing събития.',
      'Филтрите влияят на KPI картите и таблицата едновременно.',
      'Може да сменяте layout за edit панела: вдясно или под реда.',
    ],
    sections: [
      {
        title: 'Как да ползваш екрана',
        points: [
          'Горните KPI карти са summary върху текущата филтрирана селекция, а не върху всички устройства в системата.',
          'Таблицата е основният operational workspace: първо филтрираш, после отваряш конкретно устройство за проверка и редакция.',
          'Content tab в прегледа на устройство е за текущо генерирания playlist и видимите кампании за него, не за целия campaign catalog.',
        ],
      },
      {
        title: 'Кога да ползваш този екран',
        points: [
          'За live оперативна проверка на status, last seen, linked location и playlist контекст.',
          'За ръчна корекция на device-level полета като contact, name, location linkage и други metadata полета.',
        ],
      },
    ],
    definitions: [
      {
        term: 'SSE status',
        description: 'Статусът на live Server-Sent Events връзката за device updates и now-playing payload-и.',
      },
      {
        term: 'Seen 24h / Signal 24h',
        description: 'Устройството има recent operational signal в 24h window-а. Това може да дойде от HTTP, MQTT status или now-playing, не само от един source.',
      },
      {
        term: 'Needs Check 7d',
        description: 'Visible и enabled устройства без recent HTTP, MQTT status или now-playing сигнал в последните 7 дни. Това е operational shortlist за проверка.',
      },
      {
        term: 'Now playing',
        description: 'Последният известен content payload от устройството. Ако липсва, това не значи задължително, че устройството е offline.',
      },
      {
        term: 'Last seen',
        description: 'Последният timestamp, в който backend-ът е получил activity/status от устройството.',
      },
      {
        term: 'No Content',
        description: 'Няма recent proof-of-play/content signal за устройството в активния operational window. Исторически playback извън window-а не трябва да влиза тук.',
      },
      {
        term: 'Default Only',
        description: 'Има recent content signal, но само от default playlist/content. Ако има recent non-default playback, устройството не трябва да е в този filter.',
      },
      {
        term: 'Linked location',
        description: 'Дали устройството е свързано към PMI Location запис. Това влияе на location enrichment, coverage и някои справки.',
      },
      {
        term: 'CEC Linked',
        description: 'KPI count само на устройства с explicit CEC=yes в latest known status snapshot. Unknown не значи No и не влиза в count-а.',
      },
      {
        term: 'TV icon / CEC status',
        description: 'Иконката на телевизора е device-level indicator за конкретния ред. Тя може да е Unknown, дори когато KPI-то горе брои само explicit CEC=yes устройства.',
      },
      {
        term: 'Registered',
        description: 'Дали устройството има PMI registration match. В PMI Devices P това е отделно от linked location.',
      },
      {
        term: 'Normal mode',
        description: 'По-лек operational editor с основните полета и действия. Подходящ е за ежедневна работа и mobile usage.',
      },
      {
        term: 'Advanced mode',
        description: 'Показва segmentation, technical, release-target и debug полета. Ползвайте го само когато наистина трябва по-дълбока редакция.',
      },
      {
        term: 'Below row / Right side',
        description: 'Режимът, в който edit panel-ът се отваря под реда в таблицата или като страничен панел вдясно.',
      },
      {
        term: 'Valid campaigns',
        description: 'Кампании, които в момента присъстват в генерирания playlist за конкретното устройство.',
      },
      {
        term: 'Playlist content',
        description: 'Списъкът от media items, които backend-ът е върнал за устройството според текущата playlist логика.',
      },
    ],
  },
];
